import { render, staticRenderFns } from "./EventOverlay.vue?vue&type=template&id=b24e4204&scoped=true&"
import script from "./EventOverlay.vue?vue&type=script&lang=js&"
export * from "./EventOverlay.vue?vue&type=script&lang=js&"
import style0 from "./EventOverlay.vue?vue&type=style&index=0&id=b24e4204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24e4204",
  null
  
)

export default component.exports